(function() {
  function initProductMinimal(sectionEl) {
    if (!sectionEl) return;

    var mediaContainer = sectionEl.querySelector('[data-product-media]');
    if (!mediaContainer) return;

    var imgEl = mediaContainer.querySelector('.product-minimal__image');
    var prevBtn = mediaContainer.querySelector('.product-minimal__nav--prev');
    var nextBtn = mediaContainer.querySelector('.product-minimal__nav--next');

    if (!imgEl || !prevBtn || !nextBtn) return;

    // Obtener todas las imágenes desde los <img data-buffer-image>
    var bufferImages = mediaContainer.querySelectorAll('[data-buffer-image]');
    var images = [];
    for (var i = 0; i < bufferImages.length; i++) {
      var node = bufferImages[i];
      images.push({
        src: node.getAttribute('src'),
        alt: node.getAttribute('alt') || ''
      });
    }

    // Si no hay imágenes, o solo 1, no hacemos slider
    if (!images.length) return;

    if (images.length === 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      return;
    }

    var currentIndex = 0;

    function showImage(index) {
      if (index < 0 || index >= images.length) return;
      imgEl.src = images[index].src;
      imgEl.alt = images[index].alt;
    }

    function goNext() {
      currentIndex = (currentIndex + 1) % images.length;
      showImage(currentIndex);
    }

    function goPrev() {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      showImage(currentIndex);
    }

    // Eventos
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      goNext();
    });

    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      goPrev();
    });
  }

  function initAllProductMinimal() {
    var sections = document.querySelectorAll('.product-minimal');
    for (var i = 0; i < sections.length; i++) {
      initProductMinimal(sections[i]);
    }
  }

  // 1) Se ejecuta inmediatamente cuando se carga el script
  initAllProductMinimal();

  // 2) También si el script se carga antes del DOM completo
  document.addEventListener('DOMContentLoaded', initAllProductMinimal);

  // 3) Y cuando se recarga la sección en el editor de temas
  document.addEventListener('shopify:section:load', function(event) {
    var sectionEl = event.target.querySelector('.product-minimal');
    if (sectionEl) initProductMinimal(sectionEl);
  });

})();
